// extracted by mini-css-extract-plugin
export default {"root":"SidebarMenu_root__gko9B","logo":"SidebarMenu_logo__KuRt9","menu":"SidebarMenu_menu__+GXQL","menuItem":"SidebarMenu_menuItem__f1Dix"};